module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/vi/1-ddb4d0be30131ccd67515799544c7019.jpg";